@if (showInfoIcon) {
<button #infoIcon class="suggestion-icon" type="button" [attr.aria-label]="'Suggestion: ' + message"
  (pointerenter)="onInfoIconEnter($event)" (pointerleave)="onInfoIconLeave($event)"
  (focus)="onInfoIconEnter($event)" (blur)="onInfoIconBlur()" (click)="onInfoIconClick()">
  i
</button>
}
@if (!showInfoIcon || hoveringInfoIcon() || showTooltip) {
<span class="warning-tooltip" [class.suggestion-tooltip]="appearance === 'suggestion'"
  [class.warning-tooltip--below]="showInfoIcon && placement === 'below'"
  [attr.role]="announcementRole" [attr.aria-live]="ariaLive"
  [style.top.px]="tooltipTop" [style.right.px]="tooltipRight">
  <span>{{ message }}</span>
</span>
}
